import React from 'react';
import { Check } from 'lucide-react';
import { packageTiers } from '../../data/outreach';
import { formatAed, formatCompact } from '../../utils/format';
import { cn } from '../../utils/cn';
import type { PackageTierId } from '../../types/outreach';
interface PackageTiersProps {
  assignedCounts: Record<PackageTierId, number>;
  selected?: PackageTierId;
  onSelect?: (tier: PackageTierId) => void;
}
export function PackageTiers({
  assignedCounts,
  selected,
  onSelect
}: PackageTiersProps) {
  return <div className="grid gap-3 lg:grid-cols-4" data-id="element-782" data-mp="21j7mzkjzjuho">
      {packageTiers.map(tier => {
      const isSelected = selected === tier.id;
      return <article key={tier.id} className={cn('flex flex-col rounded-sm border bg-card', isSelected ? 'border-uae-green ring-1 ring-uae-green' : 'border-border')} data-id="element-783" data-mp="25nfd9m63dii0">
            <header className={cn('border-b px-4 py-3', tier.id === 'platinum' ? 'border-uae-green/20 bg-uae-green text-white' : 'border-border')} data-id="element-784" data-mp="3lz1fshmsbjuj">
              <div className="flex items-center justify-between gap-2" data-id="element-785" data-mp="hbrhq5tfphj7">
                <h3 className="text-[13px] font-semibold" data-id="element-786" data-mp="cd6hw7i3gzva">{tier.label}</h3>
                <span className={cn('rounded-sm border px-1.5 py-0.5 text-[10px]', tier.id === 'platinum' ? 'border-white/30 text-white/80' : 'border-border text-muted-foreground')} data-id="element-787" data-mp="7gg27la7c6ae">
                  {assignedCounts[tier.id] ?? 0} live
                </span>
              </div>
              <p className={cn('mt-1 font-mono text-lg font-semibold', tier.id === 'platinum' ? 'text-white' : 'text-foreground')} data-id="element-788" data-mp="3kvvv67cjetz7">
                {formatAed(tier.priceAed)}
              </p>
              <p className={cn('text-[11px]', tier.id === 'platinum' ? 'text-white/70' : 'text-muted-foreground')} data-id="element-789" data-mp="318hv1y4cfg8u">
                {tier.channelCount} channels · {formatCompact(tier.impressionGuarantee)}{' '}
                impressions guaranteed
              </p>
            </header>
            <ul className="flex-1 space-y-1.5 px-4 py-3" data-id="element-790" data-mp="3kwqr4j90c6dm">
              {tier.inclusions.map(inclusion => <li key={inclusion} className="flex items-start gap-1.5 text-[12px] leading-snug" data-id="element-791" data-mp="3oyvg34oigetx">
                  <Check className="mt-0.5 h-3 w-3 shrink-0 text-uae-leaf" aria-hidden="true" data-id="element-792" data-mp="3b7gviteyg5kr" />
                  {inclusion}
                </li>)}
            </ul>
            {onSelect && <button type="button" onClick={() => onSelect(tier.id)} aria-pressed={isSelected} className={cn('border-t border-border px-4 py-2.5 text-[12px] font-medium transition-colors', isSelected ? 'bg-uae-green text-white' : 'hover:bg-muted')} data-id="element-793" data-mp="7pyogo70b2le">
                {isSelected ? 'Filtering this tier' : 'Filter campaigns on this tier'}
              </button>}
          </article>;
    })}
    </div>;
}